import { Button } from '@components/shared/Button'
import { DownloadIcon } from '@assets/svgs/DownloadIcon'
import { Title } from '@components/shared/Title'

import type { ExportTitleProps } from './types'

import * as S from './styles'

export const ExportTitle = ({ label, onExport, isExporting }: ExportTitleProps) => {
  return (
    <Title
      label={label}
      action={
        <S.ExportAction>
          <S.ValuesLabel>Valores em R$ (Real)</S.ValuesLabel>

          <Button colorType="outlineBlue" rightIcon={<DownloadIcon />} onClick={onExport} loading={isExporting} disabled={isExporting}>
            Exportar
          </Button>
        </S.ExportAction>
      }
    />
  )
}
